import React from 'react';
import { AppsIntegrationUnifiedView } from './AppsIntegrationUnifiedView';
import { useIntegration } from './hooks/useIntegration';
export const AppsIntegrationUnified = (props) => {
    const { connectBar, status } = useIntegration({
        name: props.name,
        logoSrc: props.logoSrc,
        description: props.connectDescription,
        id: props.appId,
        returnUrl: props.returnUrl,
    });
    const connected = status === 'CONNECTED';
    return (React.createElement(AppsIntegrationUnifiedView, { connectBar: connectBar, name: props.name, longDescription: props.longDescription, helpCenterUrl: props.helpCenterUrl }, connected ? props.children : React.createElement("div", null)));
};
